import React from 'react';
import {
  Box, Grid, IconButton, TextField, Tooltip,
} from '@mui/material';
import { Field, getIn } from 'formik';
import { ReactComponent as Trash } from 'images/icons/trash.svg';
import AddIcon from '@mui/icons-material/Add';
import maskPhone from 'components/Masks/maskPhone';
import { labelField } from 'utils';

function InputGroup({ index, onAdd, onRemove }) {
  return (
    <Box display="flex" width="100%" gap={2}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} lg={4}>
          <Field name={`contacts.${index}.representative`}>
            {({ field, form }) => {
              const touched = getIn(form.touched, `contacts.${index}.representative`);
              const errors = getIn(form.errors, `contacts.${index}.representative`);

              return (
                <TextField
                  {...field}
                  fullWidth
                  inputProps={{ maxLength: 50 }}
                  id="representative"
                  label={labelField('Representante')}
                  variant="outlined"
                  name="representative"
                  type="text"
                  onChange={(event) => {
                    form.setFieldValue(field.name, event.target.value);
                  }}
                  onBlur={(e) => form.setFieldTouched(field.name, true)}
                  error={(touched && errors)}
                  helperText={(touched && errors)}
                />
              );
            }}
          </Field>
        </Grid>
        <Grid item xs={12} sm={6} lg={2}>
          <Field name={`contacts.${index}.position`}>
            {({ field, form }) => {
              const touched = getIn(form.touched, `contacts.${index}.position`);
              const errors = getIn(form.errors, `contacts.${index}.position`);

              return (
                <TextField
                  {...field}
                  fullWidth
                  inputProps={{ maxLength: 50 }}
                  id="position"
                  label={labelField('Cargo')}
                  variant="outlined"
                  name="position"
                  type="text"
                  onChange={(event) => {
                    form.setFieldValue(field.name, event.target.value);
                  }}
                  onBlur={() => form.setFieldTouched(field.name, true)}
                  error={(touched && errors)}
                  helperText={(touched && errors)}
                />
              );
            }}
          </Field>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={2}>
          <Field name={`contacts.${index}.phone_number`}>
            {({ field, form }) => {
              const touched = getIn(form.touched, `contacts.${index}.phone_number`);
              const errors = getIn(form.errors, `contacts.${index}.phone_number`);

              return (
                <TextField
                  {...field}
                  fullWidth
                  id="phone_number"
                  label={labelField('Telefone')}
                  variant="outlined"
                  // InputLabelProps={{ shrink: true }}
                  name="phone_number"
                  type="text"
                  InputProps={{
                    inputComponent: maskPhone,
                  }}
                  onChange={(event) => {
                    form.setFieldValue(field.name, event.target.value);
                  }}
                  onBlur={() => form.setFieldTouched(field.name, true)}
                  error={touched && errors}
                  helperText={touched && errors}
                />
              );
            }}
          </Field>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={2}>
          <Field name={`contacts.${index}.contact_number`}>
            {({ field, form }) => {
              const touched = getIn(form.touched, `contacts.${index}.contact_number`);
              const errors = getIn(form.errors, `contacts.${index}.contact_number`);

              return (
                <TextField
                  {...field}
                  fullWidth
                  id="contact_number"
                  label={labelField('Contato')}
                  variant="outlined"
                  // InputLabelProps={{ shrink: true }}
                  name="contact_number"
                  type="text"
                  InputProps={{
                    inputComponent: maskPhone,
                  }}
                  onChange={(event) => {
                    form.setFieldValue(field.name, event.target.value);
                  }}
                  onBlur={() => form.setFieldTouched(field.name, true)}
                  error={touched && errors}
                  helperText={touched && errors}
                />
              );
            }}
          </Field>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={2}>
          <Field name={`contacts.${index}.email`}>
            {({ field, form }) => {
              const touched = getIn(form.touched, `contacts.${index}.email`);
              const errors = getIn(form.errors, `contacts.${index}.email`);

              return (
                <TextField
                  {...field}
                  fullWidth
                  inputProps={{ maxLength: 50 }}
                  id="email"
                  label={labelField('E-mail')}
                  variant="outlined"
                  name="email"
                  type="email"
                  onChange={(event) => {
                    form.setFieldValue(field.name, event.target.value);
                  }}
                  onBlur={() => form.setFieldTouched(field.name, true)}
                  error={(touched && errors)}
                  helperText={(touched && errors)}
                />
              );
            }}
          </Field>
        </Grid>
      </Grid>
      <Grid
        item
        xs="auto"
        display="flex"
        alignItems="center"
        justifyContent="flex-end"
      >
        {index > 0 && (
          <Tooltip title="Remover">
            <IconButton sx={{ bgcolor: '#FFDAD6' }} size="large" onClick={onRemove}>
              <Trash style={{ width: 14, height: 14 }} />
            </IconButton>
          </Tooltip>
        )}

        {index === 0 && (
          <Tooltip title="Adicionar">
            <IconButton sx={{ bgcolor: '#DBE5DE' }} onClick={onAdd}>
              <AddIcon />
            </IconButton>
          </Tooltip>
        )}
      </Grid>
    </Box>
  );
}

export default InputGroup;
